<script setup lang="ts">
import { useRoute } from 'vue-router'
import { QuestionMarkCircleIcon } from '@heroicons/vue/24/solid'
import { useHelpStore } from '@/stores/useHelpStore'
import { useConfiguratorStore } from '@/stores/useConfiguratorStore'

const route = useRoute()
const helpStore = useHelpStore()
const configuratorStore = useConfiguratorStore()

function handleClick() {
  const routeName = (route.name as string) || ''
  helpStore.toggle(routeName)
}
</script>

<template>
  <button
    v-show="!configuratorStore.isOpen"
    type="button"
    class="help-button"
    aria-label="Aide"
    @click="handleClick"
  >
    <QuestionMarkCircleIcon class="help-icon" />
  </button>
</template>

<style scoped>
.help-button {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 899;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border: none;
  border-radius: 50%;
  background: #6F3B94;
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.help-button:hover {
  background: #5A2D78;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.help-button:focus-visible {
  outline: 2px solid #0066CC;
  outline-offset: 2px;
}

.help-icon {
  width: 24px;
  height: 24px;
}
</style>
